import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from 'E:/pocket-tool/.pocket-doc/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from "../../src/components/InitMenu";
import React, {useRef, useState} from "react";
import Input from "pocko-ui/Input";
export const Demo = () => {
  const _components = Object.assign({
    div: "div",
    i: "i",
    button: "button"
  }, _provideComponents());
  const inputFocusRef = useRef(null);
  return <_components.div className="mt-4">
      <Input label="Title" wrapperClassName="mb-1" />

      <Input label="disabled" defaultValue={"disabled"} wrapperClassName="mb-1" disabled />

      <Input label="number" type="number" wrapperClassName="mb-1" />

      <Input label="left/right icon" iconLeft={<_components.i className="fa-solid fa-left-long"></_components.i>} iconRight={<_components.i className="fa-solid fa-right-long"></_components.i>} wrapperClassName="mb-1" />

      <Input inputRef={inputFocusRef} label={<>
            <_components.button className="btn btn-sm btn-primary" onClick={() => {
    if (inputFocusRef.current) inputFocusRef.current.focus();
  }}>
              ref focus
            </_components.button>
          </>} iconLeft={<_components.i className="fa-solid fa-left-long"></_components.i>} iconRight={<_components.i className="fa-solid fa-right-long"></_components.i>} wrapperClassName="mb-1" />
    </_components.div>;
};
export const Demo1 = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  return <_components.div className="mt-4">
      <Input defaultValue={'no-spacing'} wrapperClassName="" />

      <Input defaultValue={'no-spacing'} wrapperClassName="position-relative" />
    </_components.div>;
};
export const Demo2 = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  return <_components.div className="mt-4">
      <Input label="Date" type="date" wrapperClassName="mb-2" />

      <Input label="DateTime" type="datetime-local" wrapperClassName="mb-2" />

      <Input label="Time" type="time" wrapperClassName="mb-2" />
    </_components.div>;
};
export const Demo3 = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  return <_components.div className="mt-4">
      <Input label="Ctrl Pressed" type="text" onPressEnter={item => {
    if (item.key == "Control") {
      alert("Ctrl pressed!");
    }
  }} />
    </_components.div>;
};
export const __toc = [{
  depth: 4,
  value: "General",
  id: "general"
}, {
  depth: 4,
  value: "No spacing",
  id: "no-spacing"
}, {
  depth: 4,
  value: "Date or DateTime",
  id: "date-or-datetime"
}, {
  depth: 4,
  value: "Keyboard Control",
  id: "keyboard-control"
}, {
  depth: 4,
  value: "API",
  id: "api"
}, {
  depth: 5,
  value: "Input",
  id: "input"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h4: "h4",
    p: "p",
    strong: "strong",
    details: "details",
    summary: "summary",
    pre: "pre",
    code: "code",
    span: "span",
    h5: "h5",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Input"}</_components.h1>{"\n"}{"\n"}<_components.h4 id="general">{"General"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p><_components.strong>{"Input"}</_components.strong><br />{"\r\nThrough mouse or keyboard input content, it is the most basic form field wrapper."}</_components.p>{"\n"}{"\n"}<Demo />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Input "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Input\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputFocusRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"disabled\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"disabled\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"disabled"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"number\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"number\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{inputFocusRef}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"btn btn-sm btn-primary\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"              "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputFocusRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputFocusRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".focus"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          >"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ref focus"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"iconLeft"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"fa-solid fa-left-long\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"iconRight"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"fa-solid fa-right-long\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"i"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-1\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="no-spacing">{"No spacing"}</_components.h4>{"\n"}<hr />{"\n"}{"\n"}<Demo1 />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Input "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Input\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'no-spacing'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'no-spacing'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"position-relative\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="date-or-datetime">{"Date or DateTime"}</_components.h4>{"\n"}<hr />{"\n"}{"\n"}<Demo2 />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Input "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Input\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Date\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"date\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'DateTime'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"datetime-local\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Time\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"time\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="keyboard-control">{"Keyboard Control"}</_components.h4>{"\n"}<hr />{"\n"}{"\n"}<Demo3 />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Input "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Input\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Input"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Ctrl Pressed\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"text\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onPressEnter"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".key "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Control\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"alert"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Ctrl pressed!\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="api">{"API"}</_components.h4>{"\n"}<hr />{"\n"}<_components.h5 id="input">{"Input"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Input "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Input'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"inputRef"}</_components.code></_components.td><_components.td>{"any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"A ref object that allows external components to programmatically focus the input field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"id"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The unique identifier for the "}<_components.code>{"input"}</_components.code>{" field. This is used to target the element in forms or labels."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"name"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The name associated with the "}<_components.code>{"input"}</_components.code>{" field. It is used to reference form data after form submission."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"size"}</_components.code></_components.td><_components.td>{"string | number"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Defines the width of the "}<_components.code>{"input"}</_components.code>{" field. Can be a string (e.g., "}<_components.code>{"'small'"}</_components.code>{", "}<_components.code>{"'large'"}</_components.code>{") or a number (e.g., "}<_components.code>{"100"}</_components.code>{" for pixel value)."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"label"}</_components.code></_components.td><_components.td>{"string | React.ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The label to be displayed for the "}<_components.code>{"input"}</_components.code>{" field. Can be a string or React component."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"labelClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The class name for the "}<_components.code>{"label"}</_components.code>{" element. Used to style the label of the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"wrapperClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The class name for the outer wrapper of the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"controlGroupWrapperClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The class name for the input group wrapper."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"controlGroupTextClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The class name for the input group text."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"iconLeft"}</_components.code></_components.td><_components.td>{"React.ReactNode | string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The icon or content to be displayed on the left side of the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"iconRight"}</_components.code></_components.td><_components.td>{"React.ReactNode | string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The icon or content to be displayed on the right side of the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"controlClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The class name for the "}<_components.code>{"input"}</_components.code>{" element itself."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"type"}</_components.code></_components.td><_components.td>{"React.HTMLInputTypeAttribute"}</_components.td><_components.td>{"\"text\""}</_components.td><_components.td>{"The type of the "}<_components.code>{"input"}</_components.code>{" field, such as "}<_components.code>{"'text'"}</_components.code>{", "}<_components.code>{"'password'"}</_components.code>{", or "}<_components.code>{"'email'"}</_components.code>{"."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"disabled"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether the "}<_components.code>{"input"}</_components.code>{" is disabled or not."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"readonly"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether the "}<_components.code>{"input"}</_components.code>{" is read-only or not."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"required"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether the "}<_components.code>{"input"}</_components.code>{" is required."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"requiredLabel"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The label or message to be shown when the "}<_components.code>{"input"}</_components.code>{" is required."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"defaultValue"}</_components.code></_components.td><_components.td>{"string | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The initial value of the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"placeholder"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The placeholder text to be displayed in the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"autoComplete"}</_components.code></_components.td><_components.td>{"\"on\" | \"off\""}</_components.td><_components.td>{"\"on\""}</_components.td><_components.td>{"Whether the "}<_components.code>{"input"}</_components.code>{" field allows autocomplete. The default is \"on\"."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"min"}</_components.code></_components.td><_components.td>{"number"}</_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The minimum value."}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"max"}</_components.code></_components.td><_components.td>{"number"}</_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The maximum value."}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"step"}</_components.code></_components.td><_components.td>{"number"}</_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The step increment."}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onChange"}</_components.code></_components.td><_components.td>{"(value: string) => void"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The callback function to be triggered when the value of the "}<_components.code>{"input"}</_components.code>{" field changes."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onBlur"}</_components.code></_components.td><_components.td>{"() => void"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The callback function to be triggered when the "}<_components.code>{"input"}</_components.code>{" field loses focus."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onFocus"}</_components.code></_components.td><_components.td>{"() => void"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The callback function to be triggered when the "}<_components.code>{"input"}</_components.code>{" field gains focus."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onPressEnter"}</_components.code></_components.td><_components.td>{"Function | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The callback function to be triggered when the Enter key is pressed in the "}<_components.code>{"input"}</_components.code>{" field."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Forms/Input.html.mdx","route":"/Forms/Input.html","timestamp":1772269194000,"pageMap":[{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"Meta","data":{"Input.html":"Input🔥","Checkbox.html":"Checkbox","Radio.html":"Radio"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"MdxPage","name":"index","route":"/"},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"DropdownMenu"}}]},{"kind":"Folder","name":"Other","route":"/Other","children":[{"kind":"MdxPage","name":"EmptyNotice.html","route":"/Other/EmptyNotice.html"},{"kind":"MdxPage","name":"Popovers.html","route":"/Other/Popovers.html"},{"kind":"Meta","data":{"EmptyNotice.html":"EmptyNotice🌈","Popovers.html":"Popovers🔈"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Notification.html","route":"/Web-Elements/Notification.html"},{"kind":"MdxPage","name":"SelectInput.html","route":"/Web-Elements/SelectInput.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"ToolTips.html","route":"/Web-Elements/ToolTips.html"},{"kind":"MdxPage","name":"Trees.html","route":"/Web-Elements/Trees.html"},{"kind":"Meta","data":{"ModalDialog.html":"ModalDialog🔥","SelectInput.html":"SelectInput🔥","ToolTips.html":"ToolTips","Table.html":"Table🔥","Trees.html":"Trees","Notification.html":"Notification"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":{"title":"Getting-Started"},"--":{"type":"separator","title":"Components"},"Web-Elements":{"title":"Web Elements"},"Forms":{"title":"Forms"},"Navigation":{"title":"Navigation"},"Other":{"title":"Other"},"contact":{"title":"Source ↗","type":"page","href":"https://github.com/chennkaibin/pocko-ui","newWindow":true}}}],"flexsearch":{"codeblocks":true},"title":"Input",headings:__toc},
  pageNextRoute: "/Forms/Input.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)